import React, { Component, Fragment } from "react";
import { useLocation, Link } from "react-router-dom";
import { useGlobal } from "reactn";
import { useTranslation } from "react-i18next";
import { getUrl } from "@outplayed/riot-assets";
import MediaQuery from "components/MediaQuery";
import GridBlock from "components/Champions/GridBlock";
import { getRoleLabel } from "lib/role_helper";
import * as generalHelper from "lib/general-helper.js";
import { numberWithCommas, parseQueryString, buildQueryParams } from "lib/general-helper.js";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getTierColor } from "lib/tierHelper";
import { showBuildToughestMatchups } from "lib/specialGameMode";
import { Champion } from "@outplayed/tooltips";

function capitalizeMulti(multi) {
  switch (multi) {
    case "ap":
    case "ad":
      return multi.toUpperCase();
    case "tank":
    case "crit":
    case "lethality":
      return multi.substring(0, 1).toUpperCase() + multi.substring(1);
    case "onhit":
      return "On Hit";
    case "red":
      return "Red";
    case "blue":
      return "Blue";
  }
}

const Matchups = (props) => {
  const { getChampionName, getNormalizedChampionName, getChampionImg } = getRiotAssetsContext();
  const { t } = useTranslation();
  const location = useLocation();
  const { matchups, matchupsCount, role } = props;

  const matchupsToDisplay =
    matchups.length < matchupsCount
      ? matchups.slice(0, matchupsCount).concat(Array(matchupsCount - matchups.length).fill(null))
      : matchups;

  return matchupsToDisplay.slice(0, matchupsCount).map((champion, index) => {
    if (champion === null) {
      return null;
    }

    const { champion_id, matches, win_rate } = champion;

    const championName = getChampionName(champion_id);
    const championNormalizedName = getNormalizedChampionName(champion_id);
    const championImg = getChampionImg(champion_id, { webp: true });
    const winRate = Math.round((100 - win_rate) * 10) / 10;

    let roleUrl;
    let search = parseQueryString(location.search.substring(1));
    if (role) {
      roleUrl = generalHelper.getRoleUrl(role);
    }

    return (
      <Link
        key={`${index}_${champion_id}`}
        className={`champion-matchup`}
        to={{
          pathname: `/lol/champions/${championNormalizedName}/build/${roleUrl}`,
          search: `?${buildQueryParams(search)}`,
          state: {
            scrollTop: true,
            persistRole: true,
          },
        }}
        onClick={enableScroll}
      >
        <div className="champion-face">
          <img src={championImg} alt={championName} />
        </div>
        <div className="champion-name">{championName}</div>
        <hr />
        <div className="matchup-stats">
          <div className={`win-rate ${getTierColor(winRate)}`}>
            <strong>{winRate}%</strong>
          </div>
          <div className="total-matches">
            {numberWithCommas(matches)} {t("Matches")}
          </div>
        </div>
      </Link>
    );
  });
};

const Mobile = (props) => {
  const { className, matchups, role } = props;
  const matchupsCount = 10;
  const location = useLocation();
  const showToughestMatchups = showBuildToughestMatchups(location);

  if (!showToughestMatchups) {
    return null;
  }

  return (
    <GridBlock classNames={`toughest-matchups ${className}`} title="Toughest Matchups">
      <div className="matchups" style={{ overflow: "auto" }}>
        <Matchups matchups={matchups} matchupsCount={matchupsCount} role={role} />
      </div>
    </GridBlock>
  );
};

const Desktop = (props) => {
  const { className, championName, matchups, matchupsCount, role, multi } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const showToughestMatchups = showBuildToughestMatchups(location);

  if (!showToughestMatchups) {
    return null;
  }

  return (
    <div className={`content-section toughest-matchups ${className}`}>
      <div className="content-section_header">
        <span style={{ marginRight: 12 }}>{t("Toughest Matchups")}</span>
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          {/* How do the translations work here, we can edit it from here? Don't need the translations doc? */}
          {multi ? (
            <span className="content-section_blurb">
              {t(`These champions counter ${capitalizeMulti(multi)} ${championName}`, {
                Champion: championName,
                Role: getRoleLabel(role),
                multi: multi,
              })}
            </span>
          ) : (
            <span className="content-section_blurb">
              {t(`These champions counter ${championName}`, { Champion: championName, Role: getRoleLabel(role) })}
            </span>
          )}
        </MediaQuery>
      </div>
      <div className="matchups" id="toughest-matchups" onMouseEnter={disableScroll} onMouseLeave={enableScroll} onWheel={onWheel}>
        <Matchups matchups={matchups} matchupsCount={matchupsCount} role={role} />
      </div>
    </div>
  );
};

const preventDefault = (e) => {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
};
const disableScroll = () => {
  document.addEventListener("wheel", preventDefault, {
    passive: false,
  });
};
const enableScroll = () => {
  document.removeEventListener("wheel", preventDefault, false);
};
const onWheel = (e) => {
  // e.preventDefault();
  const container = e.currentTarget;
  const containerScrollPosition = container.scrollLeft;
  container.scrollTo({
    top: 0,
    left: containerScrollPosition + e.deltaY + e.deltaX,
    behaviour: "smooth",
  });
};

const ToughestMatchupsHorizontal = (props) => {
  return <Desktop {...props} matchupsCount={10} />;
  // return (
  //   <React.Fragment>
  //     <MediaQuery min="MOBILE_SMALL" max="TABLET">
  //       <Mobile {...props} />
  //     </MediaQuery>
  //     <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE">
  //       <Desktop {...props} matchupsCount={10} />
  //     </MediaQuery>
  //   </React.Fragment>
  // )
};

export default ToughestMatchupsHorizontal;
